<template>
	<div class="container">
		<div class="filter-container">
			<el-input v-model="listQuery.content" :placeholder="langTxt('域名搜索')" style="width: 200px" />
			<el-button type="primary" icon="el-icon-search" @click="handleFilter">{{ langTxt('搜索') }}</el-button>
			<el-button type="success" icon="el-icon-plus" @click="handleEdit()">{{ langTxt('新增') }}</el-button>
		</div>
		<el-table v-loading="listLoading" :data="list" border fit highlight-current-row :height="height">
			<el-table-column show-overflow-tooltip :label="langTxt('域名')" prop="content"></el-table-column>
			<el-table-column width="120" :label="langTxt('状态')">
				<template slot-scope="{ row }">
					<el-switch class="switch" v-model="row.state" @change="handleModifyStatus(row, $event, 1)" :active-value="2"
						:inactive-value="1" active-color="#13ce66" active-text="ON" inactive-text="OFF"></el-switch>
				</template>
			</el-table-column>
			<el-table-column width="240" :label="langTxt('IOS跳转')">
				<template slot-scope="{ row }">
					<el-switch v-model="row.is_ios" @change="handleModifyStatus(row, $event, 2)" :active-value="2"
						:inactive-value="1" active-color="#13ce66" active-text="可跳转" inactive-text="不可跳转"></el-switch>
				</template>
			</el-table-column>
			<el-table-column :label="langTxt('拉黑临界数')" width="120" prop="limit_num"></el-table-column>
			<el-table-column :label="langTxt('操作')" width="120" class-name="small-padding fixed-width">
				<template slot-scope="{ row, $index }">
					<el-button type="text" size="mini" @click="handleEdit(row)">{{ langTxt('编辑') }}</el-button>
					<el-button type="text" size="mini" @click="handleDelete(row, $index)">{{ langTxt('删除') }}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- // 编辑 -->
		<el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
			<el-form ref="dataForm" :rules="rules" :model="temp" label-width="100px">
				<el-form-item :label="langTxt('域名')" prop="content">
					<el-input v-model="temp.content" autocomplete="on" :placeholder="langTxt('域名无需带http(s)://')" />
				</el-form-item>
				<el-form-item :label="langTxt('拉黑临界数')" prop="limit_num">
					<el-input-number v-model="temp.limit_num" size="medium" :min="3" :max="100"
						:placeholder="langTxt('达到该数量时自动拉黑')"></el-input-number>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">{{ langTxt('取消') }}</el-button>
				<el-button type="primary" @click="dialogStatus === 'create' ? createData() : updateData()">
					{{ langTxt('保存') }}
				</el-button>
			</div>
		</el-dialog>
    <!-- // 分页 -->
		<pagination v-if="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.pagesize" @pagination="getList" />

	</div>
</template>
<script>
export default {
	name: 'DomainList',

	data() {
		return {
			textMap: {
				update: 'Edit',
				create: 'Create'
			},
			dialogStatus: '',
			dialogFormVisible: false,
			temp: {},
			rules: {},
			list: null,
			listLoading: true,
			listQuery: {
				page: 1,
				pagesize: 20
			},
			total: 0,
			__i18n: {}
		};
	},

	computed: {
		height() {
			return this.$baseTableHeight();
		}
	},

	created() {
		this.getList();
		this.__i18n = this.$i18n.messages[this._i18n.locale];
	},

	methods: {
		// 搜索
		handleFilter() {
			this.getList();
		},

		// 获取列表
		getList() {
			this.listLoading = true;
			this.request.get('/domain', { params: this.listQuery }).then((ret) => {
				this.total = ret.count;
				if (ret.list.length) {
					this.list = ret.list.map(e => {
						if (e.is_ios === 0) {
							e.is_ios = 2
						}
						return e
					});
				}
			}).finally(() => {
				this.listLoading = false;
			})
		},

		// 重置编辑数据
		resetTemp() {
			this.temp = {
				id: undefined,
				state: 2,
				limit_num: 8
			};
		},

		// 提交表单
		updateData() {
			this.$refs['dataForm'].validate((valid) => {
				if (valid) {
					// 验证通过
					this.request.post('/domain-edit', this.temp).then(() => {
						this.$message.success(this.__i18n.common.editSuccess);
						const index = this.list.findIndex((v) => v.id === this.temp.id);
						this.list.splice(index, 1, this.temp);
						this.tipMsg();
					});
					this.close();
				} else {
					this.$message({
						message: this.langTxt('参数不能为空'),
						type: 'warning'
					});
				}
			});
		},

		// 编辑
		handleEdit(row) {
			this.resetTemp();
			if (!row) {
				this.dialogStatus = 'create';
			} else {
				this.temp = Object.assign({}, row); // copy obj
				this.dialogStatus = 'update';
			}
			this.dialogFormVisible = true;
			this.$nextTick(() => {
				this.$refs['dataForm'].clearValidate();
			});
		},

		// 提示
		tipMsg() {
			setTimeout(() => {
				this.$baseNotify(this.langTxt('若有修改记得让网管员修改NGINX配置哦，😁🙏！'), 'tip', 'success'); // message, title, type
			}, 200);
		},

		close() {
			this.dialogFormVisible = false;
		},

		// 状态
		handleModifyStatus(row, status, ty) {
			let postData = {
				id: row.id
			};
			if (ty == 2) {
				postData.is_ios = status;
			} else {
				postData.state = status;
			}
			this.request
				.post('/domain-edit', postData)
				.then(() => {
					this.$message.success(this.__i18n.common.stateSuccess);
					if (ty == 2) {
						row.is_ios = status;
					} else {
						row.state = status;
						this.tipMsg();
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},

		// 创建提交数据
		createData() {
			this.$refs['dataForm'].validate((valid) => {
				if (valid) {
					// 截取每一条数据
					this.request.post('/domain-add', this.temp).then(() => {
						this.$message.success(this.__i18n.common.addSuccess);
						this.close();
						this.getList();
						this.tipMsg();
					});
				}
			});
		},

		handleDelete(row, index) {
			this.$baseConfirm(this.__i18n.common.deleteTip, this.__i18n.common.tip, async () => {
				this.request.post('/domain-remove', row).then(() => {
					this.$message.success(this.__i18n.common.removeSuccess);
					this.list.splice(index, 1);
					this.tipMsg();
				});
			});
		}
	}
};
</script>
